import React, { useState, useEffect, useRef } from "react";
import * as XLSX from "xlsx";
import { ColorPickerComponent } from "@syncfusion/ej2-react-inputs";
import { useStateContext } from "../contexts/ContextProvider";

const KeywordRelationshipTable = ({ keywordColors, onColorChange, onKeywordRemove }) => {
  const [uniqueSources, setUniqueSources] = useState([]); // 고유 Source 값을 저장
  const [showPalette, setShowPalette] = useState(null);
  const [palettePosition, setPalettePosition] = useState({ top: 0, left: 0 });
  const paletteRef = useRef();
  const { currentColor } = useStateContext();

  // Load data from Excel file and extract unique sources
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/Connectivity_Matrix_positive.xlsx");
        if (!response.ok) throw new Error("Failed to fetch the Excel file");

        const arrayBuffer = await response.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Extract unique "Source" keywords
        const [headers, ...rows] = jsonData;
        const sources = rows.map((row) => row[0]); // 첫 번째 열 (Source 값)
        const uniqueSources = Array.from(new Set(sources)); // 중복 제거

        setUniqueSources(uniqueSources);
      } catch (error) {
        console.error("Error loading Excel data:", error);
      }
    };

    fetchData();
  }, []);

  // Close color palette when clicking outside
  useEffect(() => {
    const closePalette = (e) => {
      if (paletteRef.current && !paletteRef.current.contains(e.target)) {
        setShowPalette(null);
      }
    };
    document.addEventListener("mousedown", closePalette);
    return () => document.removeEventListener("mousedown", closePalette);
    
  }, []);

  const handleColorChange = (args, keyword) => {
    const newColor = args.currentValue.hex;
    onColorChange(keyword, newColor); // Notify parent about the color change
    setShowPalette(null);
  };

  const handleShowPalette = (e, keyword) => {
    const buttonRect = e.target.getBoundingClientRect(); // Get button position
    setPalettePosition({
      top: buttonRect.bottom + window.scrollY, // Position below the button
      left: buttonRect.left + window.scrollX, // Align horizontally
    });
    setShowPalette(keyword); // Set the clicked keyword for palette display
  };


  return (
    <div>
      {/* <p className="text-xl font-semibold">키워드 색상변경</p> */}

      <table
        border="1"
        cellPadding="5"
        cellSpacing="0"
        style={{ width: "100%", textAlign: "center" }} // 전체 테이블 가운데 정렬
      >
        <thead>
          <tr>
            <th>키워드(node)</th>
            <th>컬러 변경</th>
          </tr>
        </thead>
        <tbody>
          {uniqueSources.map((source, index) => (
            <tr key={index}>
              {/* <td style={{ color: keywordColors[source] || "black" }}>{source}</td> */}
              <td>{source}</td>
              <td>
                <button
                  onClick={(e) => handleShowPalette(e, source)}
                  style={{
                    // color: keywordColors[source] || "black", // 버튼 텍스트 색상 동기화
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                >
                  변경
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showPalette && (
        <div
          ref={paletteRef}
          style={{
            position: "absolute",
            top: `${palettePosition.top}px`,
            left: `${palettePosition.left}px`,
            zIndex: 1000,
            background: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <ColorPickerComponent
            mode="Palette"
            modeSwitcher={false}
            inline
            showButtons={false}
            change={(args) => handleColorChange(args, showPalette)}
          />
        </div>
      )}
    </div>
  );
};

export default KeywordRelationshipTable;
